import React, {useCallback} from "react";
import {
    composeValidators,
    regRequiredValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {
    UserIntakeYearSelectedValue,
    UserIntakeYear,
} from "../../../../containers/RegistrationLoginPage/types";
import {WithTitleField} from "../Styled";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../configureStore";
import useLevelHandler from "../../../../hooks/useLevelHandler";
import RadioGroupWrapper from "../../../HTMLEntities/RadioGroupWrapper";

interface Props {
    configuration: UserIntakeYear;
    formType: string;
}
const IntakeYear: React.FC<Props> = ({configuration}: Props) => {
    const level = useSelector((state: RootStore) => state.RegistrationLoginPage.level);
    const formType = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.signUpPageData?.formType,
    );
    const courseId = useSelector((state: RootStore) => state.RegistrationLoginPage.courseId);
    const levelCallback = useLevelHandler();
    const onChangeCallback = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const intakeYear = event.target.value;
            const validFormType: string[] = ["courseResponse", "levelSwitch"];
            if (formType && validFormType.includes(formType) && level && courseId) {
                void levelCallback({level, courseId, intakeYear: intakeYear});
            }
        },
        [levelCallback, formType, level, courseId],
    );
    return (
        <>
            <WithTitleField>
                <h3>When do you plan to start your studies?</h3>
                <RadioGroupWrapper<UserIntakeYear, UserIntakeYearSelectedValue>
                    fieldData={configuration}
                    validate={composeValidators(regRequiredValidate("Please select intake year"))}
                    onChangeCallback={onChangeCallback}
                />
            </WithTitleField>
        </>
    );
};
export default IntakeYear;
